import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CompanyHeaderState {
  comp_name: string;
  id: any;
  showCompanyDropDown?: boolean;
}
const headerCompanyInitialState: CompanyHeaderState = {
  comp_name: "",
  id: null,
  showCompanyDropDown: true,
};
const companySlice = createSlice({
  name: "company",
  initialState: headerCompanyInitialState,
  reducers: {
    setCompany: (state, action: PayloadAction<{ comp_name: string; id: any }>) => {
      state.comp_name = action.payload.comp_name;
      state.id = action.payload.id;
    },
    setCompanyDropDown: (state, action:  PayloadAction<boolean | undefined>) => {
      state.showCompanyDropDown = action.payload;
    },
  },
});

export const { setCompany, setCompanyDropDown } = companySlice.actions;
export { companySlice as CompanySlice };
export { headerCompanyInitialState };
